import { SecondaryWorkAdressToAdd } from './models/member-secondary-work-address.model';

export class LoadSecondaryWorkAddress {
  constructor(public memberId: string) { }
  static readonly type = '[SecondaryWorkAddress] LoadSecondaryWorkAddress';
}
export class LoadSecondaryWorkAddressSuccess {
  static readonly type = '[SecondaryWorkAddress] LoadSecondaryWorkAddressSuccess';
  constructor(public data: any[]) { }
}
export class LoadSecondaryWorkAddressFailure {
  static readonly type = '[SecondaryWorkAddress] LoadSecondaryWorkAddressFailure';
  constructor(public error: any) { }
}

export class AddSecondaryWorkAddress {
  constructor(public memberId: string, public data: SecondaryWorkAdressToAdd) { }
  static readonly type = '[SecondaryWorkAddress] AddSecondaryWorkAddress';
}
export class AddSecondaryWorkAddressSuccess {
  static readonly type = '[SecondaryWorkAddress] AddSecondaryWorkAddressSuccess';
  constructor(public res: any, public workAddress: SecondaryWorkAdressToAdd) { }
}
export class AddSecondaryWorkAddressFailure {
  static readonly type = '[SecondaryWorkAddress] AddSecondaryWorkAddressFailure';
  constructor(public error: any) { }
}

export class CorrectSecondaryWorkAddress {
  constructor(public memberId: string, public workAddressId: string, public workAddress: any) { }
  static readonly type = '[SecondaryWorkAddress] CorrectSecondaryWorkAddress';
}
export class CorrectSecondaryWorkAddressSuccess {
  static readonly type = '[SecondaryWorkAddress] CorrectSecondaryWorkAddressSuccess';
  constructor(public res: any, public workAddressId, public workAddress: any) { }
}
export class CorrectSecondaryWorkAddressFailure {
  static readonly type = '[SecondaryWorkAddress] CorrectSecondaryWorkAddressFailure';
  constructor(public error: any) { }
}

export class RemoveSecondaryWorkAddress {
  constructor(public memberId: string, public workAddressId: string, public effectiveUntil: Date,
    public confirmDeleteDomicileProfessionel?: boolean, public domicileProfessionelToDeleteId?: string) { }
  static readonly type = '[SecondaryWorkAddress] RemoveSecondaryWorkAddress';
}
export class RemoveSecondaryWorkAddressSuccess {
  static readonly type = '[SecondaryWorkAddress] RemoveSecondaryWorkAddressSuccess';
  constructor(public data: any) { }
}
export class RemoveSecondaryWorkAddressFailure {
  static readonly type = '[SecondaryWorkAddress] RemoveSecondaryWorkAddressFailure';
  constructor(public error: any) { }
}

export class DefineWorkAddressAsMainPracticePlace {
  constructor(public memberId: string, public workAddressId: string, public startingOn: Date) { }
  static readonly type = '[SecondaryWorkAddress] DefineWorkAddressAsMainPracticePlace';
}
export class DefineWorkAddressAsMainPracticePlaceSuccess {
  static readonly type = '[SecondaryWorkAddress] DefineWorkAddressAsMainPracticePlaceSuccess';
  constructor(public data: any) { }
}
export class DefineWorkAddressAsMainPracticePlaceFailure {
  static readonly type = '[SecondaryWorkAddress] DefineWorkAddressAsMainPracticePlaceFailure';
  constructor(public error: any) { }
}

export class CorrectWorkAddressEndDate {
  constructor(public memberId: string, public workAddressId: string, public effectiveUntil: Date) { }
  static readonly type = '[SecondaryWorkAddress] CorrectWorkAddressEndDate';
}
export class CorrectWorkAddressEndDateSuccess {
  static readonly type = '[SecondaryWorkAddress] CorrectWorkAddressEndDateSuccess';
  constructor(public data: any) { }
}
export class CorrectWorkAddressEndDateFailure {
  static readonly type = '[SecondaryWorkAddress] CorrectWorkAddressEndDateFailure';
  constructor(public error: any) { }
}

export class CancelWorkAddressEndDate {
  constructor(public memberId: string, public workAddressId: string, public effectiveUntil: Date) { }
  static readonly type = '[SecondaryWorkAddress] CancelWorkAddressEndDate';
}
export class CancelWorkAddressEndDateSuccess {
  static readonly type = '[SecondaryWorkAddress] CancelWorkAddressEndDateSuccess';
  constructor(public data: any) { }
}
export class CancelWorkAddressEndDateFailure {
  static readonly type = '[SecondaryWorkAddress] CancelWorkAddressEndDateFailure';
  constructor(public error: any) { }
}

export class CorrectWorkAddressStartDate {
  constructor(public memberId: string, public workAddressId: string, public effectiveOn: Date) { }
  static readonly type = '[SecondaryWorkAddress] CorrectWorkAddressStartDate';
}
export class CorrectWorkAddressStartDateSuccess {
  static readonly type = '[SecondaryWorkAddress] CorrectWorkAddressStartDateSuccess';
  constructor(public data: any) { }
}
export class CorrectWorkAddressStartDateFailure {
  static readonly type = '[SecondaryWorkAddress] CorrectWorkAddressStartDateFailure';
  constructor(public error: any) { }
}

export class CancelSecondaryWorkAddress {
  constructor(public memberId: string, public workAddressId: string, public effectiveUntil: Date,
    public confirmDeleteDomicileProfessionel?: boolean, public domicileProfessionelToDeleteId?: string) { }
  static readonly type = '[SecondaryWorkAddress] CancelSecondaryWorkAddress';
}
export class CancelSecondaryWorkAddressSuccess {
  static readonly type = '[SecondaryWorkAddress] CancelSecondaryWorkAddressSuccess';
  constructor(public data: any) { }
}
export class CancelSecondaryWorkAddressFailure {
  static readonly type = '[SecondaryWorkAddress] CancelSecondaryWorkAddressFailure';
  constructor(public error: any) { }
}

export class CancelProfessionalDomicileChange {
  constructor(public memberId: string, public professionalDomicileId: string, public effectiveDate: Date) { }
  static readonly type = '[ProfessionalDomiciles] CancelProfessionalDomicileChange';
}
export class CancelProfessionalDomicileChangeSuccess {
  static readonly type = '[ProfessionalDomiciles] CancelProfessionalDomicileChangeSuccess';
  constructor(public residenceId: string) { }
}
export class CancelProfessionalDomicileChangeFailure {
  static readonly type = '[ProfessionalDomiciles] CancelProfessionalDomicileChangeFailure';
  constructor(public error: any) { }
}
